import { useState } from 'react';
import { UseDisclosureResult } from './types';

export default function useDisclosure<T = unknown>(): UseDisclosureResult<T> {
  const [value, setValue] = useState<T>();

  const open = (value: T = true as T) => setValue(value);
  const close = () => setValue(undefined);

  return {
    isOpen: !!value,
    value,
    open,
    close,
  } as UseDisclosureResult<T>;
}
